import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { CompressedImage } from 'web-services/Imgix';
import { surfaceM, grayLightM, selectedM } from 'web-ui-kit/colors';
import { unsegmentedControlWithImageOnlyClicked } from 'web-ui-kit/events';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
/**
 * A selectable image with fixed aspect ratio.
 */


function UnsegmentedControlWithImageOnly(_ref) {
  var _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      imgixProps = _ref.imgixProps,
      name = _ref.name,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'unselected' : _ref$status;

  var handleClick = function handleClick() {
    dispatch({
      type: unsegmentedControlWithImageOnlyClicked,
      payload: {
        name: name,
        status: status
      }
    });
  };

  var Button = styles.Button,
      Image = styles.Image;
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      aspectRatio: aspectRatio,
      className: className,
      "data-testid": "".concat(name, " ").concat(status),
      onClick: handleClick,
      status: status
    },
    /*#__PURE__*/
    React.createElement(Image, imgixProps))
  );
}

UnsegmentedControlWithImageOnly.propTypes = {
  /** The fixed aspect ratio for the control. */
  aspectRatio: PropTypes.number,

  /** Allows extending styling with styled(UnsegmentedControlWithImageOnly) constructor. */
  className: PropTypes.string,

  /** For reporting events up to parent */
  dispatch: PropTypes.func,

  /** These properties are spread directly onto the CompressedImage.
   * See CompressedImage from web-services/Imgix for more information.
   */
  imgixProps: PropTypes.object.isRequired,

  /** A name for the control.
   * Not visible to users but useful for event handling.
  */
  name: PropTypes.string.isRequired,

  /** The control status. One of: */
  status: PropTypes.oneOf(['unselected', 'selected', 'disabled'])
};
var styles = {
  Button: styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    /** disable default browser button styles */\n    appearance: none;\n    border: none;\n    outline: none;\n    \n    /** Make the button a fixed aspect ratio */\n    height: 0;\n    padding-bottom: calc(", "% - 0.1875rem);\n    width: 100%;\n  \n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n\n    ", "\n\n    ", "\n  "])), function (p) {
    return 1 / p.aspectRatio * 100;
  }, surfaceM, grayLightM, function (p) {
    return p.status === 'disabled' && "\n      cursor: auto;\n      opacity: 0.3;\n    ";
  }, function (p) {
    return p.status === 'selected' && "\n      /** Sizing up the selected border with so using an after\n        * psuedo element to make sure the image does not jump\n        */\n      border-color: ".concat(surfaceM, ";\n      &::after {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        width: 100%;\n        height: 100%;\n        border: 2px solid ").concat(selectedM, ";\n        border-radius: 4px;\n      }\n    ");
  }),
  Image: styled(CompressedImage)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0.125rem;\n    left: 0.125rem;\n    width: calc(100% - 0.25rem);\n    height: calc(100% - 0.25rem);\n    object-fit: contain;\n\n    border-radius: 4px;\n  "])))
};
export default UnsegmentedControlWithImageOnly;